import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LocationdocumentsService } from '../../services/locationdocuments/locationdocuments.service'
import { UploadService } from '../../services/upload/upload.service';
import { documentInformation } from '../../model/document.model';
import * as momenttimezone from 'moment-timezone';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { GetDocStatusByRole } from '../../../shared/globalService';
import { ChangeLogService } from '../../services/change_log/change-log.service';
@Component({
  selector: 'app-agent-locationdocs-dialog',
  templateUrl: './agent-locationdocs-dialog.component.html',
  styleUrls: ['./agent-locationdocs-dialog.component.css']
})
export class AgentLocationdocsDialogComponent implements OnInit {

  fencingForm: boolean = false;
  siteInspectionForm: boolean = false;
  additionalDocForm: boolean = false;
  matSpinner: boolean = false;
  public submitFormData: any;
  public logFormData: any;
  chooseFile: boolean = false;
  updateFile: boolean = false;
  isFileChanged: boolean = false;
  onChangeFileName: string;
  onChangeFile: boolean = false;
  agentId: any;
  locationId: any;
  minDate = new Date();
  errMsg;
  errFlag: boolean = false;
  loginId;
  vendorName;
  uploadFlag: boolean = true;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  data: any = {
    inspectionDate: '',
    inspectionDoneBy: '',
    expirationDate: '',
    picDescription: '',
    externalURL: '',
    fileName: '',
    Filename: '',
  }
  documentInfo: documentInformation = new documentInformation();
  previousValues: any = [];
  constructor(
    private getDocStatusByRole: GetDocStatusByRole,
    private googleAnalyticsService: GoogleAnalyticsService,
    private changelogservice: ChangeLogService, private locationdocumentsService: LocationdocumentsService, public ref: ChangeDetectorRef, public dialogRef: MatDialogRef<AgentLocationdocsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public agentData: any, private uploadService: UploadService) { }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Upload a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.Filename = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    // will be used to upload the file into amazon
    this.isFileChanged = true;
  }

  ngOnInit() {
    this.vendorName = localStorage.getItem('AgentName');
    this.agentId = localStorage.getItem("AgentId");
    this.locationId = localStorage.getItem("LocationId");
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');

    if (this.agentData.data.DocumentTypeName == "Site Inspection Report") {
      this.siteInspectionForm = true;
    }
    else if (this.agentData.data.DocumentTypeName == "Pictures of Storage Lot") {
      this.fencingForm = true;
    }else if (this.agentData.data.DocumentTypeName == "Additional Documents") {
          this.additionalDocForm = true;
        }
    if (this.agentData.type === 'update') {
      this.chooseFile = false;
      this.updateFile = true;
      this.onChangeFile = true;
      let dt = new Date(this.agentData.data.InspectionDate);
      if (dt !== undefined)
        this.data.InspectionDate = dt;
      this.data.inspectionDoneBy = this.agentData.data.InspectionDoneBy;
      let pt = this.agentData.data.ExpirationDate !== null ? new Date(this.agentData.data.ExpirationDate) : '';
      if (pt !== undefined)
        this.data.expirationDate = pt;
      this.data.picDescription = this.agentData.data.PictureDescription;
      this.data.externalURL = this.agentData.data.DocumentLink;
      this.data.fileName = this.agentData.data.FileName;
      this.data.Filename = this.agentData.data.FileName;
    }

    if (this.agentData.type === 'create') {
      this.chooseFile = true;
      this.updateFile = false;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  saveDocument() {
    this.matSpinner = true;
    let today = new Date();
    this.uploadFlag = false;
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
    uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');

    if (this.isFileChanged === false && this.agentData.type === 'update') {
      this.data.Filename = this.data.fileName;
      this.submitForm();
    }
    else {
      var filePath = "Agent/" + this.agentId + "/location/" + this.locationId + "/" + this.agentData.data.DocumentTypeCode + "/";
      this.data.Filename = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath" : this.newFilePath1,
        "vendor_id": this.agentId
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
       this.signedUrl = res.Info;
       this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
        this.data.externalURL = this.newFilePath1;
        this.submitForm();
      });
      }, (err) => {
       
        this.matSpinner=false;
      });
    }
  }

  submitForm() {
    var testTimeZone ="";
    if(this.data.expirationDate){
    const setTime = new Date(this.data.expirationDate);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }
  }
    this.submitFormData = {
      "vendor_id": this.agentId,
      "location_id": this.locationId,
      "docId": this.agentData.data._id,
      "document_type": this.agentData.data.DocumentTypeCode,
      "document_name": this.agentData.data.DocumentTypeName,
      "location_type": '',
      "location_name": '',
      "document_link": this.data.externalURL,
      "filename": this.data.Filename,
      'inspection_date': new Date(this.data.InspectionDate),
      'inspection_done_by': this.data.inspectionDoneBy,
      'expiration_date': testTimeZone,
      'pic_description': this.data.picDescription,
      "DocumentStatus":  this.getDocStatusByRole.docStatusByRole()
    }
    this.logFormData = {
      "document_type": this.agentData.data.DocumentTypeName,
      "document_category": this.agentData.data.DocumentCategory,
      "transaction_type": "Add",
      "vendor_id": this.agentId
    }
    if (this.agentData.type === 'create') {
      this.submitFormData.created_by = this.loginId;
      this.submitFormData.updated_by = this.loginId;
      this.logFormData.modified_by = this.loginId;
      this.logFormData.location_id = localStorage.getItem('LocationId');
      this.locationdocumentsService.submitDocumentVal(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Create a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        if (res.Status == 200) {
          this.locationdocumentsService.load.next('success');
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => {
          }, err => {
            this.errMsg = err;
            this.errFlag = true;
            this.matSpinner=false;
          });
          this.onNoClick();
        }
      }, err => {
        this.errMsg = err;
        this.errFlag = true;
        this.matSpinner=false;
      }
      );
    } else if (this.agentData.type === 'update') {
      this.submitFormData.updated_by = this.loginId;
      this.submitFormData.fileUpdated = this.isFileChanged;
      this.logFormData.modified_by = this.loginId;
      this.locationdocumentsService.updateDueDocuments(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Update a" + ' ' + this.agentData.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
        if (res.Status == 200) {
          this.locationdocumentsService.load.next('success');
          if (this.logFormData.transaction_type == "Add") {
            this.logFormData.transaction_type = "Edit";
            this.previousValues = localStorage.getItem('old');
            this.logFormData.previous_fields = JSON.parse(this.previousValues);
            this.logFormData.collection_name = "vendor_location_documents";
            this.changelogservice.sendLogs(this.logFormData).subscribe(res => {
            }, err => {
              this.errMsg = err;
              this.errFlag = true;
              this.matSpinner=false;
            });
          }
          this.onNoClick();
        }
      }, err => {
        this.errMsg = err;
        this.errFlag = true;
        this.matSpinner=false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/agent-locationdocs-dialog/agent-locationdocs-dialog.component.ts